export default {
    approved: 'Innvilget',
    control: 'Kontroll',
    rejected: 'Avslag',
    documentsSent: 'Signering',
    documentsComplete: 'Fullført',
    newCase: 'Ny sak',
};
